const jobStatusOptions = [
    { value: 0, label: 'Pending' },
    { value: 1, label: 'In Progress' },
    { value: 3, label: 'Completed' },
    { value: 2, label: 'Cancelled' }
]
const statusOptions = [
    { value: 4, label: 'All Status' },
    { value: 0, label: 'Pending' },
    { value: 1, label: 'In Progress' },
    { value: 3, label: 'Completed' },
    { value: 2, label: 'Cancelled' }
];

export { jobStatusOptions };
export default statusOptions;